export const FADE_TIMEOUT = 300; // in ms
export const NAV_BAR_FADE_TIMEOUT = 1500; // in ms
